var scope_0 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0ccea63ac872cdfc9407bd8b54194e3a.js').default;
var scope_1 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0e2118da9a1962e4d9a0371ff5db5898.js').default;
var scope_2 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4a243ba14974f03a230f24a3d90191e7.js').default;
var scope_3 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4faeb50cc008236639e21a5fa65cf586.js').default;
var scope_4 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6c79124f9479121099517dd8aa01d2dd.js').default;
var scope_5 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b8a5cb1d896ecd83169c610da7120d1.js').default;
var scope_6 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b8e031e2426166a11d48bd7abaed73ea.js').default;
var scope_7 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/df606f39d914e930f215b6036140efb8.js').default;
var scope_8 = require('/home/runner/work/commerce-php/commerce-php/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    